import React, {useState, useEffect, forwardRef, useImperativeHandle}  from "react";

const Filter = (props, ref) => {
    const type = props.type;
    const [checked, setChecked] = useState([])
    const [sortedList, setSortedList] = useState([])

    useEffect(()=>{
        const sorted = Object.entries(props.list).sort((a,b) => (a[1] !== null && b[1] !== null) ? (a[1].toLowerCase() < b[1].toLowerCase()) ? -1 : ((b[1].toLowerCase() > a[1].toLowerCase()) ? 1 : 0) : 0);
        setSortedList(sorted)
    }, [props.list]);


    const checkboxChanged = (value)  => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value)
        } else {
            newChecked.splice(currentIndex, 1)
        }

        setChecked(newChecked)
        props.handleFilters(newChecked)
        //update this checked information into parent component 
    }

    function removeFilterCheckbox(value) {
        //uncheck checkbox
        document.getElementById(type + '-' + value).checked = false;
        checkboxChanged(value)
    }

    //methods that can be called from parent
    useImperativeHandle(ref, () => ({
        removeFilterCheckbox,
    }));

    function renderCheckboxLists() {
        return sortedList && sortedList.map((item) => (
            <div className="form-check" key={item[0]} >
                <input className="form-check-input" type="checkbox" id={`${type}-${item[1]}`} onChange={() => checkboxChanged(item[1])}/>
                <label className="form-check-label" htmlFor={`${type}-${item[1]}`}>
                    {item[1]}
                </label>
            </div>
        ));
    }

    return (
        <div id={type} className="filter-content collapse" data-bs-parent="#accordion">
            <div className="card">
                <div className="card-body" ref={ref}>
                    { renderCheckboxLists() }
                </div>
            </div>
        </div>
    );
}
export default forwardRef(Filter);